import { Link } from "react-router-dom";
import { ROUTES } from "../../routes/path";

function MobileMenu(props) {
  return (
    <div className="mobile-menu-overlay" id="mobile-menu-overlay">
      <div className="mobile-menu-overlay__inner">
        <div className="mobile-menu-overlay__header">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-6 col-8">
                {/* <!-- logo --> */}
                <div className="logo">
                  <Link to={ROUTES.HOME}>
                    <img
                      src="/logo.png"
                      className="img-fluid"
                      alt="Global Tech9 LLC logo"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-md-6 col-4">
                {/* <!-- mobile menu content --> */}
                <div className="mobile-menu-content text-end">
                  <span
                    className="mobile-navigation-close-icon"
                    id="mobile-menu-close-trigger"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-menu-overlay__body">
          <nav className="offcanvas-navigation">
            <ul>
              <li>
                <Link to={ROUTES.HOME}>Home</Link>
              </li>
              <li>
                <Link to={ROUTES.ABOUT}>About Us</Link>
              </li>
              <li>
                <Link to={ROUTES.SERVICE}>IT solutions</Link>
              </li>
              <li>
                <Link to={ROUTES.CAREER}>
                  <span>Careers</span>
                </Link>
              </li>
              <li>
                <Link to={ROUTES.FAQ}>
                  <span>FAQs</span>
                </Link>
              </li>
              <li>
                <Link to={ROUTES.CONTACT}>
                  <span>Contact Us</span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
